import {Form, Input, Layout, Modal} from "antd";
import styled from "styled-components";
import {useEffect, useRef, useState} from "react";
import {useMutation} from "react-query";
import {emailExists} from "../../../../api/User";

const CustomForm = styled(Form)`
  .ant-form-item-label > label {
    height: 32px !important;
  }
`

const CustomInput = styled(Input)`
  border-radius:4px !important;
  &:hover{
    border-color: #6ee6c6 !important;
  };
  &:focus-within{
    border-color: #6ee6c6 !important;
  }
`
export const AddAdministrator = ({loading, visible, cancel, submit}) => {
    const controller = useRef(new AbortController())
    const {mutateAsync: emailExistsMutate} = useMutation(emailExists)

    const [form] = Form.useForm()

    const checkEmailValidator = async (_, value) => {
        if (!value) {
            return Promise.reject(new Error('Please enter Email'))
        }
        if (!new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{1,20}$/g).test(value)) {
            return Promise.reject(new Error('Email is not a valid email'))
        }
        if (controller.current) controller.current.abort()
        controller.current = new AbortController()
        const res = await emailExistsMutate({email: value, signal: controller.current.signal})
        if (res.data.email_exists) {
            return Promise.reject(new Error('Email is already exists.'))
        }
        const confirmEmail = form.getFieldValue('confirmEmail')
        if (confirmEmail) form.validateFields(['confirmEmail'])
        return Promise.resolve()
    }

    const confirmEmailValidator = (_, value) => {
        const email = form.getFieldValue('email')
        if (!value) {
            return Promise.reject(new Error('Please enter Email'))
        }
        if (email !== value) {
            return Promise.reject(new Error('The email do not match!'))
        }
        return Promise.resolve()
    }

    useEffect(() => {
        if (visible) form.resetFields()
    }, [visible])

    const onSubmit = () => {
        const fields = form.getFieldsValue()
        const errors = form.getFieldsError(Object.keys(fields))
        if (errors.some(err => err.errors.length)) return

        const emptyKeys = Object.keys(fields).filter(k => !fields[k])
        if (emptyKeys.length) {
            form.validateFields(emptyKeys).then()
        } else {
            submit(fields)
        }
    }

    return (
        <Modal title='Invite Co-Administrator' open={visible} okText='Invite' okButtonProps={{style: {width: 90}}} cancelButtonProps={{style: {width: 90}}} onCancel={() => cancel()} onOk={onSubmit} confirmLoading={loading}>
            <CustomForm form={form} labelCol={{span: 6}} onFinish={submit}>
                <Form.Item hasFeedback label='Name' name='username' rules={[{required: true}]}>
                    <CustomInput />
                </Form.Item>
                <Form.Item hasFeedback label='Email' name='email' rules={[{required: true, type: 'email', validator: checkEmailValidator}]}>
                    <CustomInput />
                </Form.Item>
                <Form.Item hasFeedback label='Confirm Email' name='confirmEmail' rules={[{required: true, validator: confirmEmailValidator}]}>
                    <CustomInput />
                </Form.Item>
            </CustomForm>
        </Modal>
    )
}